<template>
    <MenuBaseSubmenu :listenerId="listenerId">
        <a :href="getLink('/links')">
            <i class="ksi ksi-links"></i>
            <span>{{ $t('lang.menu.links') }}</span>
        </a>
        <a :href="getLink('/links/domains-batch')">
            <i class="ksi ksi-links-domains-batch"></i>
            <span>{{ $t('lang.menu.links_domains_batch') }}</span>
        </a>
        <a :href="getLink('/compare?view=backlinks')">
            <i class="ksi ksi-compare"></i>
            <span>{{ $t('lang.menu.links_site_compare') }}</span>
        </a>
    </MenuBaseSubmenu>
</template>

<script>
import {Listeners} from "../../../constants/listeners";
import MenuBaseSubmenu from "./BaseSubmenu.vue";

export default {
    name: "MenuSubmenuTopLinks",
    data() {
        return {
            listenerId: Listeners.TOP_MENU_TOP_LINKS_HOVER,
        };
    },
    methods: {
        getLink(url) {
            return sprintf('/%s%s', window.locale, url);
        },
    },
    components: {
        MenuBaseSubmenu,
    },
}
</script>
